import styled from 'styled-components';
import React, {FC} from 'react';

import {mediaBreakpointDown, fontSizesMixins, fontWeights} from '../../../../lib/styleVariables';
import {Slider} from '../../../common/slider';
import {ImageTextBlock, ImageTextBlockProps} from '../../../molecules/textImageBlock';
import {StylableProps} from '../../../../lib/styleHelpers';
import {hiddenDesktopUpStyle, hiddenTabletDownStyle} from '../../../../lib/responsiveClassNames';
import {hashObject} from '../../../../lib/hashObject';

export interface DynamicImageTextXSCenteredProps {
  itemsPerRow?: number;
  rowMargin?: number;
}

interface ImageTextXSCenteredProps extends StylableProps {
  items: ImageTextBlockProps[];
  title?: string;
}

const StyledTitle = styled.h2`
  ${fontSizesMixins.h2()}
  width: 100%;
  text-align: center;
  margin-top: 0;
  margin-bottom: 50px;

  ${mediaBreakpointDown('mobile')} {
    font-weight: ${fontWeights.normal};
    margin-bottom: 24px;
  }
`;

const StyledImageTextBlock = styled(ImageTextBlock)`
  ${mediaBreakpointDown('tablet')} {
    margin: 0 auto 16px;
  }
`;

const StyledItems = styled.div`
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  ${hiddenTabletDownStyle}
`;

const StyledDesktopItem = styled.div<{itemsPerRow: number; rowMargin: number}>`
  flex-grow: 1;
  flex-shrink: 0;
  margin-top: ${props => props.rowMargin}px;
  flex-basis: ${props => 100 / props.itemsPerRow}%;
  padding-left: 12px;
  padding-right: 12px;
  display: flex;
  justify-content: center;
`;

const StyledSlider = styled(Slider)`
  ${mediaBreakpointDown('tablet')} {
    margin-bottom: 24px;
  }
  ${hiddenDesktopUpStyle}
`;

export const ImageTextXSCentered: FC<ImageTextXSCenteredProps & DynamicImageTextXSCenteredProps> = props => {
  const {items, title, rowMargin = 24, itemsPerRow = 3} = props;
  const mobileItems = items.map(item => (
    <StyledImageTextBlock size="xs" type="centered" {...item} key={hashObject(item)} />
  ));

  const desktopItems = items.map((item, i) => (
    <StyledDesktopItem
      key={hashObject(item)}
      itemsPerRow={itemsPerRow}
      rowMargin={i > itemsPerRow - 1 ? rowMargin : 0}
    >
      <StyledImageTextBlock size="xs" type="centered" {...item} />
    </StyledDesktopItem>
  ));

  return (
    <>
      {title && <StyledTitle>{title}</StyledTitle>}
      <StyledItems>{desktopItems}</StyledItems>
      <StyledSlider rowCount={1} items={mobileItems} />
    </>
  );
};
